export const TOUR_CONTAINER_TEST_ID = 'tour-container'
export const TOUR_NEXT_TEST_ID = 'tour-next'
export const TOUR_DONE_TEST_ID = 'tour-next'
